import "../../styles/NewsSection.css";
import NewsCaroussel from "../../components/NewsCaroussel";

const NewsSection = ({ news = [], isLoading }) => {
  const sortedNews = [...news].sort(
    (a, b) => new Date(b.datetimeCreation) - new Date(a.datetimeCreation),
  );

  if (isLoading || sortedNews.length === 0) {
    return null;
  }

  return (
    <div id="news" className="news-section section">
      <h2 className="section-title">En ce moment !</h2>
      <div className="slider-container">
        <NewsCaroussel newsData={sortedNews} />
      </div>
    </div>
  );
};

export default NewsSection;
